import { initAlertAutoDismiss } from "@shared/alert";

export function initAuthLogin(): void {
  const form = document.querySelector<HTMLFormElement>(".auth__form");
  if (!form || form.hasAttribute("data-auth-init")) return;
  // Guard: only run on the login form (must have a [name='login'] input)
  if (!form.querySelector("[name='login']")) return;
  form.setAttribute("data-auth-init", "");

  initPasswordToggle();
  initAutoFocus();
  initFormValidation(form);
  initAlertAutoDismiss();
}

function initPasswordToggle(): void {
  const btn = document.querySelector<HTMLButtonElement>(".auth-field__pwd-toggle");
  if (!btn) return;

  const input = document.getElementById("auth-password") as HTMLInputElement | null;
  const iconShow = btn.querySelector<SVGElement>(".auth-field__pwd-icon--show");
  const iconHide = btn.querySelector<SVGElement>(".auth-field__pwd-icon--hide");

  if (!input || !iconShow || !iconHide) return;

  btn.addEventListener("click", () => {
    const revealing = input.type === "password";
    input.type = revealing ? "text" : "password";
    iconShow.style.display = revealing ? "none" : "";
    iconHide.style.display = revealing ? "" : "none";
    btn.setAttribute("aria-label", revealing ? "Скрыть пароль" : "Показать / скрыть пароль");
  });
}

function initAutoFocus(): void {
  const loginInput = document.getElementById("auth-login") as HTMLInputElement | null;
  if (!loginInput?.value) return;
  loginInput.focus();
  const len = loginInput.value.length;
  loginInput.setSelectionRange(len, len);
}

function initFormValidation(form: HTMLFormElement): void {
  form.addEventListener("submit", (e) => {
    const login = (form.querySelector<HTMLInputElement>("[name='login']")?.value ?? "").trim();
    const password = (form.querySelector<HTMLInputElement>("[name='password']")?.value ?? "").trim();

    if (!login || !password) {
      e.preventDefault();
      e.stopImmediatePropagation();
      highlightEmptyFields(form, { login: !login, password: !password });
    }
  });
}

function highlightEmptyFields(
  form: HTMLFormElement,
  empty: { login: boolean; password: boolean },
): void {
  const loginInput = form.querySelector<HTMLInputElement>("[name='login']");
  const passwordInput = form.querySelector<HTMLInputElement>("[name='password']");

  loginInput?.classList.toggle("auth-field__input--error", empty.login);
  passwordInput?.classList.toggle("auth-field__input--error", empty.password);

  if (empty.login) loginInput?.focus();
  else if (empty.password) passwordInput?.focus();
}
